import {getManager} from "./Manager";
import {dispatchBaseClick} from "../event/DispatchEvent";
import {castHTMLElement, getShadowRoot} from "../common/SiteHelper";

export default class InteractionManager
{
    looseInputSelected:boolean = false;
    isTouchDevice:boolean = false;

    constructor()
    {
        this.preventNumberScroll();
        this.documentTouchStartListener = this.documentTouchStartListener.bind(this);
        this.documentMouseDownListener = this.documentMouseDownListener.bind(this);
        this.documentClickListener = this.documentClickListener.bind(this);
        this.isTouchDevice = this.determineIsTouchDevice();
        document.addEventListener("touchstart", this.documentTouchStartListener);
        document.addEventListener("mousedown", this.documentMouseDownListener);

    }

    determineIsTouchDevice() {
        return (('ontouchstart' in window) ||
            ((navigator.maxTouchPoints ?? 0) > 0));
    }

    preventNumberScroll():void
    {
        document.addEventListener("wheel", (event) => {
            const activeElement = (document.activeElement as HTMLInputElement) ?? null;
            if(activeElement?.type === "number"){
                activeElement?.blur();
            }
        });
    }

    documentTouchStartListener(event:any): void
    {
        if(!this.isTouchDevice){
            return
        }
        this.documentClickListener(event);
    }

    documentMouseDownListener(event:any): void
    {
        if(this.isTouchDevice){
            return
        }
        this.documentClickListener(event);
    }

    documentClickListener(event:any)
    {

        const htmlElement:HTMLElement|null = castHTMLElement(event.target);

        const getLooseInput = (htmlElement:HTMLElement|null):HTMLElement|null => {
            if(!!htmlElement && htmlElement.tagName.toLowerCase() === "input" && !!htmlElement.closest(".loose-input")){
                return htmlElement;
            }
            return null;
        }

        const looseInputTarget = getLooseInput(htmlElement);
        if(looseInputTarget){
            this.looseInputSelected = true;
        } else if(this.looseInputSelected){
            const looseInputActiveElement = getLooseInput(castHTMLElement(document.activeElement));
            this.looseInputSelected = false;
            looseInputActiveElement?.focus();
            looseInputActiveElement?.blur();

        }
        this.handleAriaHiddenBlur();
        dispatchBaseClick(htmlElement);

    }

    handleAriaHiddenBlur()
    {

        const ionPickerShadowRoot = getShadowRoot("ion-picker");
        const ionPickerColumnShadowRoot = getShadowRoot("ion-picker-column");
        const pickerBlurItems = ionPickerShadowRoot?.querySelectorAll("input") ?? null;
        const pickerColumnBlurItems = ionPickerColumnShadowRoot?.querySelectorAll("div") ?? null;

        pickerBlurItems?.forEach(el => {
            const htmlElement:HTMLElement|null = castHTMLElement(el);
            if(htmlElement){
                htmlElement.blur()
            }
        });
        pickerColumnBlurItems?.forEach(el => {
            el.removeAttribute('aria-hidden')
            const htmlElement:HTMLElement|null = castHTMLElement(el);
            if(htmlElement){
                htmlElement.blur()
            }
        })
    }
}